"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("user-profile", className, styles.root),
        photo: styling_1.mergeStyles("user-profile-photo", styles.photo),
        photoIconContainer: styling_1.mergeStyles("user-profile-photo-icon-container", styles.photoIconContainer),
        header: styling_1.mergeStyles("user-profile-header", styles.header),
        details: styling_1.mergeStyles("user-profile-details", styles.details),
        name: styling_1.mergeStyles("user-profile-name", styles.name),
        email: styling_1.mergeStyles("user-profile-email", styles.email),
        body: styling_1.mergeStyles("user-profile-body", styles.body),
        groups: styling_1.mergeStyles("user-profile-groups", styles.groups),
        group: styling_1.mergeStyles("user-profile-group", styles.group)
    };
});
exports.getClassNames = getClassNames;
